import { render, staticRenderFns } from "./CookiesControl.vue?vue&type=template&id=633ba981"
import script from "./CookiesControl.vue?vue&type=script&lang=js"
export * from "./CookiesControl.vue?vue&type=script&lang=js"
import style0 from "./CookiesControl.vue?vue&type=style&index=0&id=633ba981&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports